class PathCalc {
  constructor(props) {
    this._listeners = [];
    this._sourceModel = props.sourceMode;
    this.id = props.id;
    this.name = props.name;
    this.delay = 0;
  }
}
export default PathCalc;
